// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"app-with-qr_wrapper___kypO","image":"app-with-qr_image__tWCNc"};